
import { useRecoilState } from "recoil";
import { createTeeshotAxiosInstance } from "src/http";
import { recoilStates } from "src/recoil/recoilStates";

export default function useRefetchEventBookings() {
  const [_5, setEventApplication] = useRecoilState(recoilStates.eventApplication);
  const [_6, setInit] = useRecoilState(recoilStates.init);

  const refetchEventBooking = async () => {
    setInit({ isInit: false });
    const eventBookingRes = await createTeeshotAxiosInstance().get("/evtBooking/booking");
    if (!eventBookingRes.data.success) {
      alert("데이터 재수신 오류");
      window.location.reload();
    }
    if (eventBookingRes?.data?.data) {
      setEventApplication(eventBookingRes?.data?.data);
      setInit({ isInit: true });
    }
  };
  return refetchEventBooking;
}
